"use client";
import T from "@marginly/ui/components/typography";
import React, { useState } from "react";

import * as S from "./styled";
import Space from "components/common/space";

const QA_DATA = [
  {
    title: "What is this?",
    text: "This is a brand new co-marketing campaign with Camelot featuring a trading contest for Marginly and Camelot users.",
  },
  {
    title: "How is this different from regular trading?",
    text: "Trades get routed to Camelot where possible. Traders get rewarded by accumulating points towards the leaderboard.",
  },
  {
    title: "How does the leaderboard work?",
    text: "Traders accumulate points based on their relative PnL (%PnL). Only trades with $100+ margin qualify.",
  },
  {
    title: "Wen rewards?",
    text: "Rewards will be distributed in ARB tokens automatically to the winning traders’ EVM wallets shortly after the contest ends.",
  },
];

const QaItem = ({
  title,
  text,
}: {
  title: string;
  text: React.JSX.Element | string;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <S.QAUnit open={open} onClick={() => setOpen(!open)}>
      <div className="qa-title">
        <T headerS>{title}</T>
        <img
          src="/contest/images/qa-arrow.svg"
          alt=""
          className="arrow"
          style={{ filter: "invert(1)" }}
        />
      </div>
      <div className="qa-text">
        <T secondary>{text}</T>
      </div>
    </S.QAUnit>
  );
};

export const Qa = () => {
  return (
    <S.Wrapper>
      <T headerL style={{ textAlign: "center" }}>
        Questions & Answers
      </T>
      <Space height={40} heightMobile={20} />
      {QA_DATA.map(({ title, text }) => (
        <QaItem title={title} text={text} key={title} />
      ))}
    </S.Wrapper>
  );
};
